import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'any'
})

export class SiteSummaryService {
    constructor(protected http: HttpClient) {
    }

    baseurl = environment.apiBaseUrl;

    getCompanyOwners(siteId) {
        return this.http.get<any[]>(this.baseurl + 'SiteSummary/getcompanyowners/' + siteId);
    }

    getSiteGasSummary(siteId) {
        return this.http.get<any[]>(this.baseurl + 'SiteSummary/getsitegassummary/' + siteId);
    }

    getOnsiteSupplies(siteId) {
        return this.http.get<any[]>(this.baseurl + 'SiteSummary/GetOnsiteSupplies/' + siteId);
    }

    getOnsiteDemands(siteId) {
        return this.http.get<any[]>(this.baseurl + 'SiteSummary/GetOnsiteDemands/' + siteId);
    }

    getPipelineSupplies(siteId) {
        return this.http.get<any[]>(this.baseurl + 'SiteSummary/GetPipelineSupplies/' + siteId);
    }

    getPipelineDemands(siteId) {
        return this.http.get<any[]>(this.baseurl + 'SiteSummary/GetPipelineDemands/' + siteId);
    }

    getProductionFacilities(siteId) {
        return this.http.get<any[]>(this.baseurl + 'SiteSummary/GetProductionFacilities/' + siteId);
    }


}